import { isServer } from './platform-utils'

export const appendClassName = (element: HTMLElement, className: string) => {
    if (element) {
        element.classList.add(className)
    }
}

export const removeClassName = (element: HTMLElement, className: string) => {
    if (element) {
        element.classList.remove(className)
    }
}

export function getSafeDisableProps(shouldDisable: boolean, customProp?: string) {
    return isServer ? {} : shouldDisable ? { [customProp ? customProp : 'disabled']: true } : {}
}
